<template>
  <div>
    <HoverBtn
      v-if="isHoverMenu"
      :hover="hover"
      :disabled="menu"
      tooltip="Додати блок"
      icon="add"
      @handler="openMenu"
    />
    <v-menu
      v-else
      v-model="menu"
      min-width="450"
      max-width="450"
      max-height="600"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <IconBtn icons="add" :small="true" v-on="on" v-bind="attrs" />
      </template>
      <v-card style="max-height: 600px; overflow: hidden;">
        <v-card-title class="pb-0">
          <v-row align="center" no-gutters>
            <v-col cols="11">
              <SelectTags
                v-model="tagsForDocument"
                :multiple-select="true"
                label="Теги для пошуку блоків"
              />
            </v-col>
            <v-col cols="1">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <IconBtn
                    icons="add"
                    v-on="on"
                    class="mx-1"
                    @click="$emit('edit', '0')"
                  />
                </template>
                <span>{{ tooltip }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-list style="max-height: 520px; height: auto; overflow: auto;">
            <v-list-item v-if="!blocks.length">
              Блоків із заданими тегами не найдено
            </v-list-item>
            <v-list-item v-for="block in blocks" :key="block.id">
              <InfiniteScroll @intersect="handleScroll(block.id)" />
              <DocumentBlockMiniViewer
                :value="block"
                @add="add(block.id)"
                @get-items="getDocumentsByBlock(block.id)"
              />
            </v-list-item>
          </v-list>
          <div class="text-center">
            <DialogItemsList
              v-model="dialog"
              :items="documents"
              :loading="loading"
              header="Список документів"
              @close="dialog = false"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import DocumentBlockMiniViewer from "./DocumentBlockMiniViewer.vue";
import InfiniteScroll from "../../components/InfiniteScroll.vue";
import DialogItemsList from "../../components/DialogItemsList.vue";
import IconBtn from "../../components/IconBtn.vue";
import HoverBtn from "../../components/HoverBtn.vue";
import { getBlocks } from "../../backend/document-blocksApi.js";
import { getDocumentsByBlock } from "../../backend/documentsApi.js";

export default {
  components: {
    DocumentBlockMiniViewer,
    InfiniteScroll,
    DialogItemsList,
    IconBtn,
    HoverBtn,
    SelectTags: () => import("../tags/SelectTags.vue"),
  },
  props: {
    icon: {
      type: String,
      default: "search",
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      blocks: [],
      currentPage: 1,
      perPage: 9,
      totalBlocks: 0,
      documents: [],
      dialog: false,
      loading: false,
      tagsForDocument: [],
      tooltip: "Створити блок",
      menu: false,
      isHoverMenu: true,
    };
  },
  created() {
    this.getBlocksByTags();
  },
  watch: {
    tagsForDocument() {
      this.currentPage = 1;
      this.blocks = [];
      this.getBlocksByTags();
    },
    menu(val) {
      if (!val) {
        this.isHoverMenu = true;
      }
    },
  },
  computed: {
    fullItems() {
      const items = this.blocks.filter(
        (item, index, arr) =>
          arr.findIndex(({ id }) => item.id === id) === index
      );
      if (Array.isArray(this.tagsForDocument)) {
        return this.tagsForDocument.concat(items);
      } else if (typeof this.tagsForDocument === "object") {
        return this.tagsForDocument ? [this.tagsForDocument, ...items] : items;
      } else {
        return items;
      }
    },
  },
  methods: {
    openMenu() {
      this.isHoverMenu = false;
      setTimeout(() => {
        this.menu = true;
      }, 200);
    },
    handleScroll(id) {
      if (this.totalBlocks <= this.fullItems.length) return;
      const position = this.fullItems.findIndex((item) => item.id === id);

      if (position === this.fullItems.length - 2) {
        this.getMoreBlocks();
      }
    },
    getBlocksByTags() {
      let url = "";
      for (let t = 0; t < this.tagsForDocument.length; t++) {
        url += `&tags=${this.tagsForDocument[t].id}`;
      }
      getBlocks(this.currentPage, this.perPage, url).then((res) => {
        this.totalBlocks = res.totalItems;
        this.blocks = [...this.blocks, ...res.result];
      });
    },
    getMoreBlocks() {
      this.currentPage += 1;
      this.getBlocksByTags();
    },
    add(blockId) {
      this.$emit("add", blockId);
    },
    async getDocumentsByBlock(blockId) {
      this.dialog = true;
      this.loading = true;
      this.documents = [];
      this.documents = await getDocumentsByBlock(blockId);
      this.loading = false;
    },
  },
};
</script>
